import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { ChevronUp, ChevronDown, Sparkles, Receipt } from 'lucide-react';

const TaxRates = ({
 showTaxRates,
 setShowTaxRates,
 formData,
 setFormData,
 aiEstimatedFields,
 openAIDialog
}) => {
 return (
 <Card className="border-2 border-amber-200 dark:border-amber-800">
 <CardHeader className="cursor-pointer" onClick={() => setShowTaxRates(!showTaxRates)}>
 <div className="flex items-center justify-between">
 <div>
 <CardTitle className="flex items-center gap-2">
 <Receipt className="w-5 h-5 text-amber-600" />
 Tax Rates
 </CardTitle>
 <CardDescription>Sales tax and business income tax rates</CardDescription>
 </div>
 {showTaxRates ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
 </div>
 </CardHeader>
 {showTaxRates && (
 <CardContent>
 <div className="bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
 <div className="grid grid-cols-2 gap-4">
 <div className="space-y-2">
 <div className="flex items-center justify-between">
 <Label className="text-sm font-medium">Sales Tax Rate (%)</Label>
 <Button
 type="button"
 variant="ghost"
 size="sm"
 onClick={() => openAIDialog('sales_tax_rate', 'Sales Tax Rate (%)')}
 className="h-6 text-xs"
 >
 <Sparkles className="w-3 h-3 mr-1" />
 Ask AI
 </Button>
 </div>
 <Input
 type="number"
 step="0.01"
 value={formData.sales_tax_rate}
 onChange={(e) => setFormData(prev => ({ ...prev, sales_tax_rate: e.target.value }))}
 placeholder="0.00"
 className={aiEstimatedFields.sales_tax_rate ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20' : ''}
 />
 {aiEstimatedFields.sales_tax_rate && (
 <p className="text-xs text-amber-700 dark:text-amber-300">
 <Sparkles className="w-3 h-3 inline mr-1" />
 AI: {aiEstimatedFields.sales_tax_rate.explanation}
 </p>
 )}
 <p className="text-xs text-muted-foreground">
 Tax added to customer purchase price
 </p>
 </div>
 
 <div className="space-y-2">
 <div className="flex items-center justify-between">
 <Label className="text-sm font-medium">Business Income Tax (%)</Label>
 <Button
 type="button"
 variant="ghost"
 size="sm"
 onClick={() => openAIDialog('income_tax_rate', 'Business Income Tax (%)')}
 className="h-6 text-xs"
 >
 <Sparkles className="w-3 h-3 mr-1" />
 Ask AI
 </Button>
 </div>
 <Input
 type="number"
 step="0.01"
 value={formData.income_tax_rate}
 onChange={(e) => setFormData(prev => ({ ...prev, income_tax_rate: e.target.value }))}
 placeholder="0.00"
 className={aiEstimatedFields.income_tax_rate ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20' : ''}
 />
 {aiEstimatedFields.income_tax_rate && (
 <p className="text-xs text-amber-700 dark:text-amber-300">
 <Sparkles className="w-3 h-3 inline mr-1" />
 AI: {aiEstimatedFields.income_tax_rate.explanation}
 </p>
 )}
 <p className="text-xs text-muted-foreground">
 Tax on your business profits
 </p>
 </div>
 </div>
 </div>
 </CardContent>
 )}
 </Card>
 );
};

export default TaxRates;
